import React, { useEffect, useState } from 'react';
import Pagination from "src/component/Global/Pagination"
import "floating-scroll";
import System from 'src/helper/system';
import Helper from 'src/helper/Helper';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { isObject } from "underscore";
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import RefreshStockButton from 'src/pages/ProductListing/RefreshStockButton';
import produceClone from "src/helper/produceClone";
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import ShowMoreLess from 'src/component/custom/ShowMoreLess';
import usePreviousState from "../../../hooks/usePreviousState";
import { Tooltip } from 'src/component/Global/Tooltip';
import stickyTableHeader from 'src/helper/stickyTableHeader';
import Constants from 'src/helper/Constants';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import { useProductStore } from 'src/hooks/product';
import DisplayQtyMinQtyMult from 'src/component/custom/DisplayQtyMinQtyMult';
import { __remove, __set } from "../../../store/axios_indicator";
import ProductInventoryDisplay from 'src/component/custom/ProductInventoryDisplay';
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import { useQuoteStore } from 'src/hooks/quote';
import { useSystem } from "src/hooks/system";

export function QuoteDetailListTable() {

    const { QuoteTabList: { APR, BKD, PND, NBD }, siteUser } = Constants
    let QuoteTabType = System.getParams().__c_QuoteDetailTabList || APR.param_value;
    QuoteTabType = QuoteTabType === APR.param_value ? 'Approved' : QuoteTabType === BKD.param_value ? 'Booked' : QuoteTabType === PND.param_value ? 'Pending' : QuoteTabType === NBD.param_value ? 'NoBid' : 'Expired'

    const [__check] = useAxiosIndicatorCheck();
    const [list, setList] = useState({});
    const c = System.getParams();
    const quoteNumber = c.quote_number;
    const [{ filter_list }, { }, { }] = useObjCommonFilterStore();
    const [{ get_current_quote_cart, line_items, cart_quote_active_session }, { fetch_line_items, set_SelectAll_Qty }, { toggle_quote_cart_line_item, select_all_quantity }] = useQuoteStore();
    const [currentStatus, set_currentStatus] = useState(line_items[QuoteTabType]);
    const [{ }, { get_inventory_by_id, get_inventory_params }, { }] = useProductInventoryPriceStore();
    const [selectedAllQty, setSelectedAllQty] = useState("");
    const selectedSessionList = get_current_quote_cart();
    const [{ productList }, { get_product_assets }, { }] = useProductStore();
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: 'quotelinenumber',
        sortOrder: 'ASC',
        ascDesField: {}
    })
    const preLimit = usePreviousState(listObj.limit);
    const prePage = usePreviousState(listObj.page);
    const preSortBy = usePreviousState(listObj.sortBy);
    const preSortOrder = usePreviousState(listObj.sortOrder);
    const [, { get_quantity_format }] = useSystem();


    const noRecordMsg = `Sorry! We can't find any results based on your selection.`;

    useEffect(() => {

        async function selected_Quantity() {
            const _selectedQty = await set_SelectAll_Qty(currentStatus?.records, selectedSessionList, currentStatus?.slug, productList);
            setSelectedAllQty(_selectedQty)
        }

        selected_Quantity()
    }, [selectedSessionList, currentStatus, currentStatus?.records]);

    useEffect(() => {
        async function fetchHere() {

            let isIncludeCnt = true;

            if (((preLimit ? preLimit : listObj.limit) !== listObj.limit) || ((prePage ? prePage : listObj.page) !== listObj.page) || ((preSortBy ? preSortBy : listObj.sortBy) !== listObj.sortBy) || ((preSortOrder ? preSortOrder : listObj.sortOrder) !== listObj.sortOrder)) {
                isIncludeCnt = false
            }

            await fetchAPICall(isIncludeCnt)
        }

        fetchHere();
    }, [listObj.page, listObj.limit, listObj.sortBy, listObj.sortOrder, filter_list]);

    useEffect(() => {
        set_currentStatus(line_items[QuoteTabType])
    }, [line_items])

    const fetchAPICall = async (isIncludeCnt) => {
        let quoteStatus;
        quoteStatus = QuoteTabType === 'NoBid' ? 'No Bid' : QuoteTabType

        __set('LINE_ITEM_API_CALL');
        await fetch_line_items({
            "quoteNumber": quoteNumber,
            "quoteStatus": quoteStatus,
            "pageNumber": listObj.page,
            "pageSize": listObj.limit,
            "sortBy": listObj.sortBy,
            "sortType": listObj.sortOrder,
            "manufacturer": filter_list.manufacturer?.searchKeyword || null,
            "manufacturerPartNumber": filter_list.manufacturerPartNumber?.searchKeyword || null,
            "customerPartNumber": filter_list.customerPartNumber?.searchKeyword || null,
            "includeOtherQuoteCount": isIncludeCnt
        })
        __remove('LINE_ITEM_API_CALL');
    };

    useEffect(() => {
        if (currentStatus && Object.keys(currentStatus).length > 0) {
            const total = currentStatus.count;
            setList(currentStatus.records)
            setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
        } else {
            setList({})
            setListObj({
                pageCount: 0,
                page: 1,
                limit: 20,
                sortBy: 'quotelinenumber',
                sortOrder: 'ASC',
                ascDesField: {}
            })
        }
    }, [currentStatus, currentStatus?.records, line_items]);

    const getSelectedQtyStrFromQuoteCartSession = (quoteNumber, lineItemNumber, selectedQty) => {
        if (cart_quote_active_session[quoteNumber]) {
            const quote = cart_quote_active_session[quoteNumber];
            const qty = quote.records?.[lineItemNumber]?.quantity_field_selected;
            return qty === selectedQty
        }
        return false;
    }

    const handlePageClick = async (data) => {
        setListObj({ ...listObj, page: (data.selected + 1) });
        Helper.scrollTop();
    };

    const setPageLimit = async (event) => {
        setListObj({ ...listObj, limit: Number(event.target.value), page: 1 });
    };

    const onSelectQty = (e, qty, lineItem) => {
        const _item = { ...lineItem };
        _item.quantity_field_selected = e.target.checked ? qty : false;
        toggle_quote_cart_line_item(_item)
    }

    const onSelectAllQty = (e) => {
        const checkedAllQty = e.target.value;
        const data = { quoteNumber: quoteNumber, list: {} }
        if (e.target.checked) {
            const dataList = produceClone(list);
            Object.entries(dataList).map((v) => {
                if (v[1][`sellQuantity_${checkedAllQty}`] && v[1][`sellQuantity_${checkedAllQty}`] > 0 && v[1]?.ERPPartNumber && productList[v[1].ERPPartNumber] && productList[v[1].ERPPartNumber]?.Published) {
                    if (currentStatus?.api_query_param === 'A' && v[1][`quotedPrice_${checkedAllQty}`] && v[1][`quotedPrice_${checkedAllQty}`] > 0) { // note - both condition is same
                        v[1].quantity_field_selected = checkedAllQty;
                    } else {
                        v[1].quantity_field_selected = checkedAllQty;
                    }

                    data.list[v[0]] = v[1];
                }
            });
        }
        if (selectedSessionList && Object.entries(selectedSessionList).length > 0) {
            const selectedList = produceClone(selectedSessionList);
            Object.entries(selectedList).map((v) => {
                if (v[1].status !== currentStatus?.slug)
                    data.list[v[0]] = v[1];
            });
        }

        select_all_quantity(data);
    }

    const refreshStock = async () => {
        const params = [];
        list && Object.entries(list).map((v, i) => {
            const param = get_inventory_params(productList[v[1].ERPPartNumber])
            if (param) {
                params.push(param)
            }
        })

        if (params && params.length) {
            await get_product_assets(params, { isPriceCall: false })
        }
    }

    const disableQtyChk = (item, qty, quotedPrice) => {
        let result = false
        if (item[1]?.ERPPartNumber && productList[item[1].ERPPartNumber] && qty > 0 && productList[item[1].ERPPartNumber]?.Published) {
            result = true;
            if (currentStatus?.api_query_param === 'A') {
                result = (quotedPrice && quotedPrice > 0);
            }
        }

        return result;
    }

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DSC' : 'ASC';
        } else {
            listObj.ascDesField[columnName] = 'ASC'
        }
        setListObj({ ...listObj, sortBy: columnName, sortOrder: listObj.ascDesField[columnName], ascDesField: listObj.ascDesField })
    };

    useEffect(() => {

        let isDisplayFixedHeader;
        let refreshStockButton;
        let callback;

        if ((isObject(list) && Object.entries(list).length > 0)) {
            const sort = toggleOrderBy;
            const tableElement = document?.getElementById("quotedetail-table");
            // headerHeght contains height where we need to display static header
            // local
            // const headerHeight =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
            // sbx
            let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 156;

            // Admin Toolbar header height adjustment
            const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

            if (adminToolBarHeight > 0) {
                headerHeight = headerHeight + adminToolBarHeight;
            }
            // is used to track only one header will display at a moment
            // extra function attach 
            document.addEventListener("scroll", (ScrollEvent) => {
                // current table position from top
                const tablePosition = tableElement && tableElement.getBoundingClientRect() ? tableElement.getBoundingClientRect().y : false;
                const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")[0]?.getBoundingClientRect()?.y : false;

                if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
                    // function used to display header clone after actual header height is less than headerHeight from top
                    if (!document.getElementById("table_copy")) {
                        callback = stickyTableHeader("quotedetail-table", headerHeight, "sticky-table-wrapper", 1, sort)
                        isDisplayFixedHeader = true;
                        refreshStockButton = document.getElementsByClassName("refresh-link")
                        refreshStockButton[1].addEventListener("click", refreshStock);
                        for (let i = 1; i <= 3; i++) {
                            if (document.getElementsByClassName('chk_qty_' + i).length > 0 && onSelectAllQty) {
                                document.getElementsByClassName('chk_qty_' + i)[document.getElementsByClassName('chk_qty_' + i).length - 1]?.addEventListener("change", (evt) => onSelectAllQty(evt));
                            }
                        }
                    }
                } else {
                    if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                        // switch variable to false for track that clone header hide
                        isDisplayFixedHeader = false;
                        // check element exist before remove event listeners
                        if (refreshStockButton && refreshStockButton[1] && refreshStock) {
                            refreshStockButton[1]?.removeEventListener("click", refreshStock);
                        }
                        // check element exist before remove event listeners
                        for (let i = 1; i <= 3; i++) {
                            if (document.getElementsByClassName('chk_qty_' + i).length > 0 && onSelectAllQty) {
                                document.getElementsByClassName('chk_qty_' + i)[document.getElementsByClassName('chk_qty_' + i).length - 1]?.removeEventListener("change", onSelectAllQty);
                            }
                        }
                        // function used to remove the clone header
                        if (Object.prototype.toString.call(callback) == '[object Function]') {
                            callback();
                        }
                    }
                }
            })
            return () => {
                if (callback) {
                    // switch variable to false for track that clone header hide
                    isDisplayFixedHeader = false;
                    // check element exist before remove event listeners
                    if (refreshStockButton && refreshStockButton[1] && refreshStock) {
                        refreshStockButton[1]?.removeEventListener("click", refreshStock);
                    }
                    // check element exist before remove event listeners
                    for (let i = 1; i <= 3; i++) {
                        if (document.getElementsByClassName('chk_qty_' + i).length > 0 && onSelectAllQty) {
                            document.getElementsByClassName('chk_qty_' + i)[document.getElementsByClassName('chk_qty_' + i).length - 1]?.removeEventListener("change", onSelectAllQty);
                        }
                    }

                    // function used to remove the clone header
                    callback();
                    // window.scrollTo(0, 0)
                }
            }
        }
    }, [list, __check(['LINE_ITEM_API_CALL']).status])

    return (
        <>
            <div className="tab-content p-0">
                {__check(['LINE_ITEM_API_CALL', 'QUOTE_API_CALL']).render}
                {(!__check(['LINE_ITEM_API_CALL', 'QUOTE_API_CALL']).status) &&
                    <>
                        {(isObject(list) && Object.entries(list).length > 0) ?
                            <div id="tab1" className="tab-pane active table-container">
                                <div id='sticky-table-wrapper' className="table-responsive sticky-table-wrapper">
                                    <table id='quotedetail-table' className="bs5 table table-bordered search-products-table customer-quote-table ">
                                        <thead>
                                            <tr>
                                                <th className="minw100"></th>
                                                <th aria-label='QUOTEDMFRPARTNUMBER' className={`minw280 ${getOrderByClass('QUOTEDMFRPARTNUMBER')}`} onClick={async () => { await toggleOrderBy('QUOTEDMFRPARTNUMBER') }}> Part Information</th>
                                                <th className='minw170'>
                                                    <div className="checkbox"><label className="text-nowrap">

                                                        {(currentStatus?.api_query_param !== 'P') &&
                                                            <input type="checkbox" value="quantity_1"
                                                                className='chk_qty_1'
                                                                onClick={(e) => onSelectAllQty(e)}
                                                                checked={selectedAllQty === "quantity_1"}
                                                                onChange={e => { }}
                                                            />
                                                        }Quantity 1</label>
                                                    </div>
                                                </th>
                                                <th className='minw170'>
                                                    <div className="checkbox">
                                                        <label className="text-nowrap">
                                                            {(currentStatus?.api_query_param !== 'P') &&
                                                                <input type="checkbox" value="quantity_2"
                                                                    className='chk_qty_2'
                                                                    onClick={(e) => onSelectAllQty(e)}
                                                                    checked={selectedAllQty === "quantity_2"}
                                                                    onChange={e => { }}
                                                                />}Quantity 2</label>
                                                    </div>
                                                </th>
                                                <th className='minw170'>
                                                    <div className="checkbox"><label className="text-nowrap">
                                                        {(currentStatus?.api_query_param !== 'P') &&
                                                            <input type="checkbox" value="quantity_3"
                                                                className='chk_qty_3'
                                                                onClick={(e) => onSelectAllQty(e)}
                                                                checked={selectedAllQty === "quantity_3"}
                                                                onChange={e => { }}
                                                            />
                                                        }Quantity 3</label>
                                                    </div>
                                                </th>

                                                <th className='minw250'>Stock/Lead Time
                                                    <RefreshStockButton fetchInventoryFromServer={() => refreshStock()} label={'Refresh Stock'} />
                                                </th>
                                                <th className="minw280">COMMENTS</th>
                                                <th>Description</th>
                                                <th>Additional Charge(S) </th>
                                                <th>End Customer</th>
                                                <th>Ship-to Information</th>
                                                <th>Information</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.entries(list).map((ele, i) => (
                                                <tr key={ele[0]}>
                                                    <td>
                                                        {(System.avUserInfoData.currentUser === siteUser.CORE) && (
                                                            <a href={void (0)}
                                                                onClick={() => {
                                                                    System.popup('QuoteMessagePopup', { single_quote_detail_item: ele[1] })
                                                                }}
                                                            >
                                                                <Tooltip position={'right'}
                                                                    opener={() => (<i className="fa fa-envelope text-blue font-16" aria-hidden="true"></i>)}
                                                                    content={() => (
                                                                        <div>
                                                                            Click to send a question or comment to your sales representative.
                                                                        </div>
                                                                    )}
                                                                />

                                                            </a>
                                                        )}
                                                    </td>
                                                    <td className="partnumber-detail">
                                                        <div className='d-flex'>
                                                            <label>Manufacturer: </label>
                                                            <span>{ele[1]?.manufacturer}</span>
                                                        </div>
                                                        <div className='d-flex'>
                                                            <label>Mfg Part #: </label>
                                                            {productList[ele[1].ERPPartNumber]?.ItemNumber ?
                                                                <NavigateToProductDetail
                                                                    data={{ SEOManufacturerName: productList[ele[1].ERPPartNumber]?.SEOManufacturerName, SEOERPMFRPartNumber: productList[ele[1].ERPPartNumber]?.SEOERPMFRPartNumber, ItemNumber: productList[ele[1].ERPPartNumber]?.ItemNumber, ERPPartNumber: productList[ele[1].ERPPartNumber]?.ERPPartNumber }}>
                                                                    <div className="text-blue">
                                                                        <b>{productList[ele[1].ERPPartNumber]?.ERPMFRPartNumber}</b>
                                                                    </div>
                                                                </NavigateToProductDetail>
                                                                : ele[1].manufacturerPartNumber}
                                                        </div>
                                                        <div className='d-flex'>
                                                            <label>Addt’l Charges(s): </label>
                                                            <span>{ele[1]?.additionalCharges}</span>
                                                        </div>
                                                        {(currentStatus?.api_query_param === 'A' && !productList[ele[1].ERPPartNumber]?.ItemNumber) &&
                                                            <p className="error">
                                                                Sales assistance required—item not available online.
                                                            </p>
                                                        }
                                                    </td>

                                                    <td>

                                                        <div>
                                                            <label>Sell Qty1:</label>
                                                            <span>{(currentStatus?.api_query_param !== 'P') ? <b>{ele[1]?.sellQuantity_quantity_1 ? get_quantity_format(ele[1]?.sellQuantity_quantity_1) : '——'}</b> : '——'}</span>
                                                        </div>
                                                        <div>
                                                            <label>Target Price:</label>
                                                            <span>{ele[1]?.targetPrice_quantity_1 || '——'}</span>
                                                        </div>
                                                        <div>
                                                            <label>Quoted Price:</label>
                                                            <span>{currentStatus?.api_query_param !== 'P' ? ele[1]?.quotedPrice_quantity_1 || '——' : '——'}</span>
                                                        </div>
                                                        {(currentStatus?.api_query_param !== 'P') && <>
                                                            <div
                                                                className={disableQtyChk(ele, ele[1].sellQuantity_quantity_1, ele[1]?.quotedPrice_quantity_1) ? 'checkbox' : 'checkbox disable'}>
                                                                <label className="text-blue">
                                                                    <input type="checkbox"
                                                                        name={`qty1_${i}`}
                                                                        disabled={!disableQtyChk(ele, ele[1].sellQuantity_quantity_1, ele[1]?.quotedPrice_quantity_1)}
                                                                        checked={getSelectedQtyStrFromQuoteCartSession(ele[1].quoteNumber, ele[1].quoteLineNumber, 'quantity_1')}
                                                                        onClick={(e) => onSelectQty(e, 'quantity_1', ele[1])}
                                                                        onChange={e => { }}
                                                                    />Select qty 1
                                                                </label>
                                                            </div>
                                                        </>}
                                                    </td>
                                                    <td>
                                                        <div><label>Sell Qty2:</label>
                                                            <span>{currentStatus?.api_query_param !== 'P' ?
                                                                <b>{ele[1]?.sellQuantity_quantity_2 ? get_quantity_format(ele[1]?.sellQuantity_quantity_2) : '——'}</b> : '——'}</span>
                                                        </div>
                                                        <div>
                                                            <label>Target Price:</label>
                                                            <span>{ele[1]?.targetPrice_quantity_2 || '——'}</span>
                                                        </div>
                                                        <div>
                                                            <label>Quoted Price:</label>
                                                            <span>{currentStatus?.api_query_param !== 'P' ? ele[1]?.quotedPrice_quantity_2 ? ele[1]?.quotedPrice_quantity_2 : '——' : '——'}</span>
                                                        </div>

                                                        {(currentStatus?.api_query_param !== 'P') &&
                                                            <div className={disableQtyChk(ele, ele[1].sellQuantity_quantity_2, ele[1]?.quotedPrice_quantity_2) ? 'checkbox' : 'checkbox disable'}>
                                                                <label className="text-blue">
                                                                    <input type="checkbox"
                                                                        disabled={!disableQtyChk(ele, ele[1].sellQuantity_quantity_2, ele[1]?.quotedPrice_quantity_2)}
                                                                        name={`qty2_${i}`}
                                                                        checked={getSelectedQtyStrFromQuoteCartSession(ele[1].quoteNumber, ele[1].quoteLineNumber, 'quantity_2')}
                                                                        onClick={(e) => onSelectQty(e, 'quantity_2', ele[1])}
                                                                        onChange={e => { }} />
                                                                    Select qty 2
                                                                </label>
                                                            </div>
                                                        }
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <label>Sell Qty3:</label>
                                                            <span>{currentStatus?.api_query_param !== 'P' ? <b>{ele[1]?.sellQuantity_quantity_3 ? get_quantity_format(ele[1]?.sellQuantity_quantity_3) : '——'}</b> : '——'}</span>
                                                        </div>
                                                        <div>
                                                            <label>Target Price:</label>
                                                            <span>{ele[1]?.targetPrice_quantity_3 || '——'}</span>
                                                        </div>
                                                        <div>
                                                            <label>Quoted Price:</label>
                                                            <span>{currentStatus?.api_query_param !== 'P' ? (ele[1]?.quotedPrice_quantity_3 ? ele[1]?.quotedPrice_quantity_3 : '——') : '——'}</span>
                                                        </div>

                                                        {(currentStatus?.api_query_param !== 'P') &&
                                                            <div className={disableQtyChk(ele, ele[1].sellQuantity_quantity_3, ele[1]?.quotedPrice_quantity_3) ? 'checkbox' : 'checkbox disable'}>
                                                                <label className="text-blue">
                                                                    <input type="checkbox"
                                                                        name={`qty3_${i}`}
                                                                        disabled={!disableQtyChk(ele, ele[1].sellQuantity_quantity_3, ele[1]?.quotedPrice_quantity_3)}
                                                                        checked={getSelectedQtyStrFromQuoteCartSession(ele[1].quoteNumber, ele[1].quoteLineNumber, 'quantity_3')}
                                                                        onClick={(e) => onSelectQty(e, 'quantity_3', ele[1])}
                                                                        onChange={e => { }} />
                                                                    Select qty 3
                                                                </label>
                                                            </div>
                                                        }
                                                    </td>

                                                    <td>
                                                        {__check(['PRODUCT_INVENTORY_API_CALL']).render}
                                                        {!__check(['PRODUCT_INVENTORY_API_CALL']).status &&
                                                            <>
                                                                <div className="text-darkgreen d-flex align-items-center">
                                                                    <ProductInventoryDisplay single_product={productList[ele[1].ERPPartNumber]}
                                                                        single_product_inventory={get_inventory_by_id(productList[ele[1].ERPPartNumber]?.ItemNumber)}
                                                                    />
                                                                </div>
                                                                <div className="clearfix list-text availibility-list-text">
                                                                    <DisplayQtyMinQtyMult single_product={productList[ele[1].ERPPartNumber]} />
                                                                </div>
                                                            </>
                                                        }
                                                    </td>
                                                    <td>
                                                        {ele[1]?.comments}
                                                    </td>
                                                    <td>
                                                        {productList[ele[1].ERPPartNumber]?.ShortDescription ?
                                                            <ShowMoreLess single_product={productList[ele[1].ERPPartNumber]} /> : '——'}
                                                    </td>
                                                    <td>
                                                        {(ele[1]?.additionalCharge1 || ele[1]?.additionalCharge2) ? (
                                                            <>
                                                                <div>
                                                                    <label>Set Up Charge:</label>
                                                                    <span> {ele[1]?.additionalCharge1 && '$' + parseFloat(ele[1]?.additionalCharge1)?.toFixed(2)} </span>
                                                                </div>
                                                                <div>
                                                                    <label>Lot Charge:</label>
                                                                    <span> {ele[1]?.additionalCharge2 && '$' + parseFloat(ele[1]?.additionalCharge2)?.toFixed(2)} </span>
                                                                </div>
                                                            </>
                                                        ) : '——'}
                                                    </td>
                                                    <td>
                                                        {ele[1].endCustomerName ? ele[1].endCustomerName : '——'}
                                                    </td>
                                                    <td>
                                                        {Object.values(ele[1]?.shipToAddress[0])?.join(', ')}
                                                    </td>
                                                    <td>
                                                        <div className='bs5'>
                                                            <ul className="list-text plp-info-ledgend">
                                                                <ProductLegends
                                                                    single_product={productList[ele[1].ERPPartNumber]}
                                                                    onlyIconTitle={true}
                                                                />
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            :
                            <div className='mt-2'>
                                <NoResultContent message={noRecordMsg} isDisplay={false} />
                            </div>

                        }
                    </>
                }
            </div>
            {
                isObject(list) && Object.entries(list).length > 0 &&
                <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1}
                    limit={listObj.limit} />
            }
        </>
    );

}
